// extracted by mini-css-extract-plugin
module.exports = {"scheme-introdution":"SchemeIntroduction_scheme-introdution_1eMKg","is-full-mode":"SchemeIntroduction_is-full-mode_3qyCs"};